import {createContext, useContext} from "react";
import {IStaticContent} from "../../../static-content";


const StaticContentContext = createContext<IStaticContent>({
    packages: [],
});


/**
 * The provider for the static content context.
 */
export const StaticContentProvider = StaticContentContext.Provider;


/**
 * A hook that returns the static content object.
 */
const useStaticContent = () => {
    return useContext(StaticContentContext);
}

export default useStaticContent;
